<div class="social-media-post">
  <div class="embed-wrapper" #embedWrapper></div>
  @if (component?.description) {
  <div class="description">{{ component!.description }}</div>
  }
</div>
